import React from "react";
import { LockClosedIcon, CalendarIcon } from "@heroicons/react/solid";

export default function Login(props) {
  return (
    <>
      <div className="min-h-full flex items-center justify-center py-12 px-6">
        <div className="max-w-md w-full space-y-8">
          <div>
            <span className="mx-auto h-12 w-auto flex justify-center">
              <CalendarIcon
                className="h-13 w-13 text-primaryGreen"
                aria-hidden="true"
              />
            </span>

            <h2 className="mt-3 text-center text-5xl font-extrabold text-primaryGreen">
              daCalenda
            </h2>
            <h4 className="text-center my-6">
              This web app lets you see how many hours you spend on specific
              events in any of your Google Calendars.
              <br />
              <br /> It uses the Google Calendar API to fetch your calendars and
              events. You can filter the results by calendar, keyword and a
              custom time range.
            </h4>
          </div>
          <p className="mt-2 text-center text-sm text-secondaryGreen">
            To access your calendar, login to your Google account
          </p>
          <form className="mt-8 space-y-6" action="#" method="POST">
            <div>
              <button
                onClick={props.login}
                type="button"
                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-primaryGreen hover:bg-secondaryGreen focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondaryGreen"
              >
                <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                  <LockClosedIcon
                    className="h-5 w-5 text-thirdYello group-hover:text-fourthOrange"
                    aria-hidden="true"
                  />
                </span>
                Sign in with Google
              </button>
              <h3 className="mt-12 text-center font-bold text-sm text-secondaryGreen">
                {" "}
                Privacy Policy
              </h3>
              <h4 className="text-center mt-1 text-xs text-secondaryGreen">
                This app connects to the Google Calendar API to fetch your
                calendars and events, so that it can calculate the hours. This
                connection happens directly from your browser to the Google API.
                There are no server or services involved that might cache the
                data. None of the data fetched from the Google Calendar API is
                stored outside your browser. After you close the browser
                window/tab all authentication data is deleted ( sessionStorage
                is used). Thats why you need to reauthorize with Google the next
                time you visit the page. This app only has read-only access to
                your calendar data.
              </h4>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
